import React from 'react';
import { get, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

import RangeCalendar from 'rc-calendar/lib/RangeCalendar';
import Picker from 'rc-calendar/lib/Picker';
import 'rc-calendar/assets/index.css';

const format = 'YYYY MM DD';

class DateFacet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      value: [],
    };
  }

  disabledDate(current) {
    return current.isAfter();
  }

  render() {
    const { value, disabled } = this.state;
    const { dates, updateRecallsDates, noResult } = this.props;
    const [ start, end ] = dates;

    const calendar = (
      <RangeCalendar
        defaultValue={[start, end]}
        showClear
        showOk={false}
        dateInputPlaceholder={['Start date', 'End date']}
        disabledDate={this.disabledDate}
        onSelect={ updateRecallsDates }
      />
    );

    return (
      <div className="date-picker">
        <div className="date-picker-title">
          <FormattedMessage id="filter.date" />
        </div>
        <div>
          <Picker className="ant-calendar-picker-input ant-input"
            value={value}
            animation="slide-up"
            defaultValue={[start, end]}
            calendar={calendar}
          >
            {
              ({ value }) => {
                return (
                  <span>
                    <input
                      value={!isEmpty(dates) ? [start.format(format), end.format(format)] : []}
                      placeholder="Start date   ~   End date"
                      disabled={disabled}
                      readOnly
                      className="ant-calendar-picker-input ant-input"
                    />
                  </span>
                );
              }
            }
          </Picker>
        </div>
      </div>
    )
  }
}

export default DateFacet;



// WEBPACK FOOTER //
// ./src/views/recalls-list/facets/date-facet.js